import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navigation } from '@/mocks/navigation';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  const isHome = location.pathname === '/';
  const isTransparent = isHome && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-18">
        <Link
          to="/"
          className="flex items-center gap-2 group cursor-pointer"
        >
          <div className="w-8 h-8 md:w-9 md:h-9 bg-primary-500 rounded-lg flex items-center justify-center">
            <i className="ri-quill-pen-line text-background-50 text-lg"></i>
          </div>
          <span className={`text-xl md:text-2xl font-heading font-bold tracking-tight transition-colors duration-300 ${isTransparent ? 'text-background-50' : 'text-foreground-900'}`}>
            一起草
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navigation.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={`relative px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                isActive(item.href)
                  ? isTransparent
                    ? 'text-background-50 bg-background-50/15'
                    : 'text-primary-600 bg-primary-50'
                  : isTransparent
                    ? 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              <i className={`${item.icon} mr-1.5 text-xs`}></i>
              {item.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="/login"
            className={`px-4 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${isTransparent ? 'text-background-50/80 hover:text-background-50' : 'text-foreground-600 hover:text-foreground-900'}`}
          >
            登录
          </a>
          <a
            href="/register"
            className="px-5 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            免费注册
          </a>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${isTransparent ? 'text-background-50 hover:bg-background-50/10' : 'text-foreground-700 hover:bg-background-100'}`}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 animate-in">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navigation.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  isActive(item.href)
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                <i className={item.icon}></i>
                {item.name}
              </Link>
            ))}
            <div className="border-t border-background-200 mt-2 pt-3 flex gap-2">
              <a
                href="/login"
                className="flex-1 text-center px-4 py-2.5 text-sm font-medium text-foreground-700 border border-background-300 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              >
                登录
              </a>
              <a
                href="/register"
                className="flex-1 text-center px-4 py-2.5 text-sm font-medium bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer"
              >
                免费注册
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}